import { Button, Input, Typography } from 'antd'

const { Text } = Typography
const { TextArea } = Input

// In-flow side panel: sits beside the form in a flex row so the form narrows instead of being overlapped.
export default function ReturnSidePanel ({
  open,
  title,
  description,
  placeholder = 'Explain what needs to be changed',
  value,
  onChange,
  onCancel,
  onSubmit,
  submitLabel,
  submitting = false,
  fixedRight = false
}) {
  if (!open) return null

  return (
    <div
      className='tti-return-panel'
      style={{
        width: fixedRight ? 'min(440px, calc(100vw - 32px))' : 440,
        flexShrink: 0,
        alignSelf: 'flex-start',
        position: fixedRight ? 'fixed' : 'sticky',
        top: 16,
        right: fixedRight ? 16 : undefined,
        zIndex: fixedRight ? 1100 : undefined,
        height: 'calc(100vh - 120px)',
        display: 'flex',
        flexDirection: 'column',
        marginTop: 20,
        marginRight: fixedRight ? 0 : 20,
        background: '#ffffff',
        border: '1px solid #e5e5e5',
        borderRadius: 8,
        boxShadow: '-4px 0 16px rgba(0, 0, 0, 0.08)',
        padding: 20
      }}
    >
      {/* Figma "Textarea field 2" (node 887:18277): Bold 16 label, outlined
          textarea, and a secondary-style pill Send button flush right. */}
      <div style={{ fontWeight: 700, fontSize: 16, lineHeight: 1.5, color: 'var(--tti-grey)', marginBottom: 4 }}>{title}</div>
      <Text type='secondary'>{description}</Text>
      <TextArea
        style={{ marginTop: 12, flex: 1, minHeight: 100, resize: 'none' }}
        placeholder={placeholder}
        value={value}
        onChange={event => onChange(event.target.value)}
      />
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>
        <Button type='text' onClick={onCancel} disabled={submitting}>Cancel</Button>
        <Button loading={submitting} onClick={onSubmit}>
          {submitLabel}
        </Button>
      </div>
    </div>
  )
}
